import { Theme, css } from '@emotion/react';

export const searchInputContainer = ({ spacing }: Theme) => css`
  margin: ${spacing(1.5)}px ${spacing(2.5)}px 0;
`;

export const currentLocationButton = ({ spacing }: Theme) => css`
  margin: ${spacing(1.5)}px ${spacing(2.5)}px 0;
  width: calc(100% - ${spacing(5)}px);
`;

export const searchResultsList = ({ spacing }: Theme) => css`
  margin: ${spacing(1.5)}px 0;
`;
